import { render, staticRenderFns } from "./SelectProdiAll.vue?vue&type=template&id=2a847542"
import script from "./SelectProdiAll.vue?vue&type=script&lang=js"
export * from "./SelectProdiAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports